/**
 * Device/environment info for diagnostics (009). Reads the same helpers the app
 * uses to pick the capture profile (008), so the report shows what the device was
 * actually asked to capture.
 */
import { isMobileDevice } from '../room/deviceProfile.js'
import { videoCaptureConstraints, videoMaxBitrate } from '../room/media.js'

export interface DeviceInfo {
  userAgent: string
  userAgentDataMobile?: boolean | undefined
  maxTouchPoints?: number | undefined
  isMobile: boolean
  captureProfile: {
    width?: number | undefined
    height?: number | undefined
    fps?: number | undefined
    maxBitrateKbps: number
  }
  viewport: { w: number; h: number; dpr: number }
  buildId?: string | undefined
}

function idealOf(c: ConstrainULong | ConstrainDouble | undefined): number | undefined {
  if (typeof c === 'number') return c
  return (c as { ideal?: number } | undefined)?.ideal
}

export function collectDeviceInfo(): DeviceInfo {
  const mobile = isMobileDevice()
  const nav = navigator as Navigator & { userAgentData?: { mobile?: boolean } }
  const constraints = videoCaptureConstraints(mobile)

  return {
    userAgent: navigator.userAgent,
    userAgentDataMobile: nav.userAgentData?.mobile,
    maxTouchPoints: navigator.maxTouchPoints,
    isMobile: mobile,
    captureProfile: {
      width: idealOf(constraints.width),
      height: idealOf(constraints.height),
      fps: idealOf(constraints.frameRate),
      maxBitrateKbps: Math.round(videoMaxBitrate(mobile) / 1000),
    },
    viewport: { w: window.innerWidth, h: window.innerHeight, dpr: window.devicePixelRatio },
    buildId: import.meta.env.VITE_BUILD_ID,
  }
}
